import React, { useState, useRef, useEffect } from 'react';
import {
    List, Datagrid, TextField, SimpleList, Button as RaButton, useRefresh, usePermissions, FunctionField
} from 'react-admin';
import {
    useMediaQuery, makeStyles, CircularProgress, Dialog, DialogContent, DialogActions, TextField as MuiTextField, Typography, Button, FormControl, InputLabel, Select, MenuItem, Avatar
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import ParkingSearchSelector from "./components/ParkingSearchSelector";
import AddIcon from '@material-ui/icons/Add';
import config from "./config.json";
import * as CSV from 'csv-string';
import AssignmentTurnedInOutlinedIcon from '@material-ui/icons/AssignmentTurnedInOutlined';
import CustomSearch from './components/CustomSearch';
import CustomFilter from './components/CustomFilter';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import CustomExportButton from './components/CustomExportButton';
import queryString from 'query-string';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';
import { stringify } from 'query-string';
import Autocomplete from '@material-ui/lab/Autocomplete';
import GetAppIcon from '@material-ui/icons/GetApp';
import { vehicleSvgs } from "./sharedData";

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
});

const CATEGORY = "PERMIT INVENTORY SECTION"

export const RfidInventoryList = props => {
    const eventTracker = UseAnalyticsEvent()
    const classes = useStyles();
    const location = useLocation()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const { permissions } = usePermissions();
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const refresh = useRefresh();
    const listDataRef = useRef();

    const [allocateDialogVisible, setAllocateDialogVisible] = useState(false);
    const [batchId, setBatchId] = useState("");
    const [parking, setParking] = useState(null);
    const [loading, setLoading] = useState(false);

    const [parkingName, setParkingName] = useState(null)
    const [replaceLoading, setReplaceLoading] = useState(false);
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    const [hideParkingColumn] = useState(sessionStorage.getItem("hide_parking_column") === "1");
    const [allowAddInventoryTags] = useState(sessionStorage.getItem("allow_add_inventory_tags") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Rfid", "Tag ID", "Batch ID"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Rfid");
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)

    let filterTypesInitState = [
        {
            resourcePath: "rfidOrganization",
            filterType: "Organization",
            dataList: [],
            searchList: [],
            listType: "Dynamic",
            resourceParam: "name",
            source: "organization",
            showFilter: permissions === "admin"
        },
        {
            filterType: "Action",
            dataList: [{ name: "ISSUED", id: 2 }, { name: "NOT ISSUED", id: 3 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Vehicle",
            dataList: [ { name: "Bike", id: 2 }, { name: "Car", id: 4 }, { name: "Unassigned", id: -1 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
    ]

    const [settingFilterFormat, setSettingFilterFormat] = useState({})

    const filter = { ...settingFilterFormat, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const renderVehicleType = row => (
        row.vehicle_type ?
            <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
                <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 4 }} alt="Vehicle Icon" />
            </div>
            :
            <div style={{display: 'flex', alignItems: "center", justifyContent: "center"}}>
                <div style={{color: "#334D6E", backgroundColor: "#EBEFF2", fontSize:"9px", width:"65px", textAlign:"center", borderRadius:"5px"}}>unassigned</div>
            </div>
    );

    const renderAction = action => {
        var color;
        switch (action) {
            case "ISSUED": color = customTheme.palette.primary.main; break;
            case "NOT ISSUED": color = customTheme.palette.error.main; break;
            default: color = customTheme.palette.secondary.main;
        }

        return <div style={{ color }}>{action}</div>;
    }

    const closeAllocateDialog = () => {
        setAllocateDialogVisible(false);
    };

    const allocateTags = () => {
        if (batchId == null || batchId === "") {
            notify("Batch ID is Required", "warning");
            return;
        }
        // if (batchId.search(/^\d+$/g) === -1) {
        //     notify("Invalid Batch ID", "warning");
        //     return;
        // }
        if (parking == null && typeof parking !== "object") {
            notify("Parking is Required", "warning");
            return;
        }

        setLoading(true);
        const params = {
            user_id: sessionStorage.getItem("user_id"),
            batch_id: batchId,
            access_key_id: parking.id
        };
        fetch(`${config.HOST_NAME}/crm/v3/rfidInventory/allocate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(params)
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false);
                if (json.success) {
                    closeAllocateDialog();
                    setBatchId("");
                    setParking(null);
                    eventTracker(CATEGORY, "PERMIT TAGS ALLOCATED")
                    notify('RFID Tags Allocated', "success");
                    refresh();
                } else {
                    notify(json.message, "warning");
                }
            })
            .catch(error => {
                setLoading(false);
                notify('Error allocating RFID Tags', 'warning');
            });
    };

    const getExportFile = (fileType) => {
        const {current : {total, currentSort, filterValues}} = listDataRef
        const params = {
            filter: JSON.stringify({ ...filter, ...filterValues }),
            sort: JSON.stringify([currentSort.field, currentSort.order]),
            page: 1,
            perPage: total,
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/rfidInventory?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/${fileType}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                tempLinkElement.setAttribute('download', `${currentParking && currentParking.name ? currentParking.name : "RFID Inventory Tags"}.${fileType}`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    const replaceTags = () => {
        if (batchId == null || batchId === "") {
            notify("Batch ID is Required", "warning");
            return;
        }
        if (parking == null && typeof parking !== "object") {
            notify("Parking is Required", "warning");
            return;
        }

        setReplaceLoading(true);
        const params = {
            user_id: sessionStorage.getItem("user_id"),
            batch_id: batchId,
            access_key_id: parking.id
        };
        fetch(`${config.HOST_NAME}/crm/v3/rfidInventory/replace`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(params)
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setReplaceLoading(false);
                if (json.success) {
                    closeAllocateDialog();
                    setBatchId("");
                    setParking(null);
                    notify('RFID Tags Replaced', "success");
                    refresh();
                } else {
                    notify(json.message, "warning");
                }
            })
            .catch(error => {
                setReplaceLoading(false);
                notify('Error replacing RFID Tags', 'warning');
            });
    };

    React.useEffect(() => {
        if (batchId) {
            fetch(`${config.HOST_NAME}/crm/v3/parkingNameByBatchId/${batchId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                },
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then(json => {
                    if (json.success) {
                        setParkingName(json.data)
                    } else {
                        setParkingName(null)
                        notify(json.message, 'info');
                    }
                })
                .catch((error) => {
                    notify('Error While Fetching Parking by Batch ID', 'warning');
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [batchId])


    React.useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Organization") {
                    values = { ...values, organization: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Action") {
                    values = { ...values, action: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Vehicle") {
                    values = { ...values, vehicle_type: filterListValue[val].id ? filterListValue[val].id : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        eventTracker(CATEGORY, " PERMIT TAGS LIST")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter &&
                <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                />
            }

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
            {/* <RaButton className='buttonStyle addBorderRadius' title='Add'>
                        <>
                            <AddIcon style={{fontSize: 22}}/>
                            <input type="file" accept=".csv" onChange={onCsvUpload} style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "inherit" }} />
                        </>
                    </RaButton> */}
            {!viewOnly && (permissions === "admin" || allowAddInventoryTags) && <>
                <UploadInventoryTags />
                <RaButton className='buttonStyle addBorderRadius' title="Allocate" onClick={() => setAllocateDialogVisible(true)}>
                    <AssignmentTurnedInOutlinedIcon style={{ fontSize: 22 }} />
                </RaButton>
            </>
            }
            {!viewOnly && <CustomExportButton getCSV={getExcelFile} disabled={listDataRef.current && listDataRef.current.total === 0} />}
        </div>
            {/* <div style={{fontStyle:"italic", display:"flex", justifyContent:"flex-start", marginTop:10,}}>
                <p style={{marginRight:50}}>2 Wheeler Tags - </p>
                <p style={{marginRight:50}}>4 Wheeler Tags - </p>
                <p style={{marginRight:50}}>LF Tags - </p>
            </div> */}
        <List
            {...props}
            style={{marginTop: 10}}
            title="RFID Inventory"
            bulkActionButtons={false}
            sort={{ field: "rfid", order: "ASC" }}
            exporter={false}
            filter={filter}
            empty={false}
            actions={false}
            pagination={<CustomPagination setListData={(listData) => {listDataRef.current = listData}} />}
        >
            {isSmallDevice ?
                <SimpleList
                    primaryText={record => record["rfid"]}
                    secondaryText={record => (<div>
                       {!hideParkingColumn && <div style={{ color: customTheme.palette.secondary.main }}>{record["parking_name"] ? `Parking Name: ${record["parking_name"]}` : ""}</div>}
                        <div>{record["tid"] ? `TID: ${record["tid"]}` : ""}</div>
                        <div>{record["tag_id"] ? `Tag ID: ${record["tag_id"]}` : ""}</div>
                        <div>{record["secret_code"] ? `Secret Code: ${record["secret_code"]}` : ""}</div>
                        <div>{record["batch_id"] ? `Batch ID: ${record["batch_id"]}` : ""}</div>
                        <div style={{display:"flex", justifyContent:"flex-start", alignItems:"center", gap: 10}}>Vehicle Type: {record && renderVehicleType(record)}</div>
                        {permissions === "admin" && <div>{record["organization"] ? `Company Name: ${record["organization"]}` : ""}</div>}
                    </div>)}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid className='customStyleDataGrid' component={ScrollableTable}>
                    <TextField source="rfid" label="RFID" />
                    <TextField source="tid" label="TID" />
                    <TextField source="tag_id" label="Tag ID" />
                    <TextField source="secret_code" label="Secret Code" />
                    <TextField source="batch_id" label="Batch ID" />
                    {!hideParkingColumn && <TextField source="parking_name" label="Parking Name" />}
                    <FunctionField source="vehicle_type" label="Vehicle Type"render={record => record && renderVehicleType(record)}/>
                    <FunctionField source="issue_status" label="Status" render={record => record && renderAction(record["issue_status"])} />
                    {permissions === "admin" && <TextField source="organization" label="Company Name" />}
                </Datagrid>
            }
        </List>

        <Dialog fullWidth open={allocateDialogVisible} onClose={closeAllocateDialog}>
                <Typography style={{ fontSize: 19, fontWeight: "bold", padding: "16px 24px" }}>Allocate/Replace Tags</Typography>
                <DialogContent style={{ display: "grid", gridRowGap: 20 }}>
                    <div>
                        <MuiTextField
                            variant="outlined"
                            size="small"
                            label="Batch ID"
                            value={batchId}
                            onChange={(event) => {
                                // if (!isNaN(event.target.value))
                                setBatchId(event.target.value);
                            }}
                            maxLength={9}
                        />
                        {
                            parkingName && batchId &&
                            <p style={{ lineHeight: "1px", fontSize: 14 }}><strong>{parkingName}</strong> is associate with the <strong>Batch ID {batchId}</strong></p>
                        }
                    </div>
                    <ParkingSearchSelector
                        value={parking}
                        onChange={setParking}
                        clearable={false}
                        zones={true}
                        size="small"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeAllocateDialog} disabled={loading}>Cancel</Button>
                    {parkingName && batchId && <Button color="secondary" onClick={replaceTags} disabled={replaceLoading}>{replaceLoading ? "Replacing..." : "Replace"} {replaceLoading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}</Button>}
                    <Button color="primary" onClick={allocateTags} disabled={loading}>{loading ? "Allocating..." : "Allocate"} {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}</Button>
                </DialogActions>
            </Dialog>
    </div>
};

function UploadInventoryTags() {
    const [dialogVisible, setDialogVisible] = useState(false);
    const [loading, setLoading] = useState(false)
    const [file, setFile] = useState("");
    const [fileType, setFileType] = useState(".csv")
    const [accessKeyId, setAccessKeyId] = useState("")
    const [options, setOptions] = useState([]);
    const [autovalue, setAutoValue] = useState("");
    const [inputValue, setInputValue] = useState("");
    const [batchId, setBatchId] = useState("")
    const [secretCode, setSecretCode] = useState("")

    const openDialog = () => setDialogVisible(true);

    const closeDialog = () => {
        setDialogVisible(false)
        resetStates()
    };

    const fileHandler = (event) => {
        const file = event.target.files[0];
        setFile(file)
    };

    const fileTypeHandler = (event) =>  setFileType(event.target.value);

    const onCsvUpload = event => {
        // console.log("file.type:", file.type);
        if (file && ["text/csv", "application/vnd.ms-excel"].includes(file.type)) {
            var reader = new FileReader();
            reader.onload = function (e) {
                const csvData = CSV.parse(reader.result);
                if (csvData.length === 0) {
                    notify("No Data in the file", "warning");
                    return;
                }
                const params = {
                    user_id: sessionStorage.getItem("user_id"),
                    csvData: csvData,
                    batch_id: batchId,
                    secret_code: secretCode,
                    access_key_id: accessKeyId
                };
                setLoading(true)
                fetch(`${config.HOST_NAME}/crm/v3/rfidInventory`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                        'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                    },
                    body: JSON.stringify(params)
                })
                    .then(response => {
                        saveTokens(response)
                        return response.json()
                    })
                    .then(json => {
                        if (json.success) {
                            notify('RFID Tags Added', "success");
                            closeDialog()
                        } else {
                            notify(json.message, "warning");
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        notify('Error adding RFID Tags', 'warning');
                    })
                    .finally(() =>setLoading(false))
            }
            reader.readAsText(file);
        } else {
            notify("Invalid File Format", "warning");
        }

    };

    const fetchParkings = () => {
        const token = sessionStorage.getItem('token');
        if (token != null && token !== "") {
            //setLoading(true);
            var params = {
                user_id: sessionStorage.getItem("user_id"),
                filter: JSON.stringify({ name: inputValue ? inputValue : undefined }),
                sort: JSON.stringify(["id", "ASC"]),
                page: 1,
                perPage: 10
            }
            fetch(`${config.HOST_NAME}/crm/v3/uniqueParkingAccessKeys?${stringify(params)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
                },
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then((responseJson) => {
                    if (responseJson.success) {
                        let data = responseJson.data
                        let results = []
                        for (let val in data) results.push({ access_key_id: data[val].id, name: data[val].name })
                        setOptions([...results])

                    } else notify(responseJson.message, 'warning');
                })
                .catch((e) => {
                    notify('Error fetching data', 'warning');
                    console.log(e);
                });
        }
    };

    const resetStates = () => {
        setFile("")
        setFileType("")
        setAccessKeyId("")
        setOptions([])
        setAutoValue("")
        setInputValue("")
        setBatchId("")
        setSecretCode("")
    }

    const getSampleFile = () => {
        const url = "https://files.parksmart.in/main/sample/Inventory_Tags_Sample_Csv_File.csv"
        const tempLinkElement = document.createElement('a');
        tempLinkElement.target = "_blank";
        tempLinkElement.href = url;
        let filename;
        if (typeof url === "string") {
            const urlKeys = url.split("/");
            filename = urlKeys[urlKeys.length - 1];
        } else {
            filename = "Download";
        }
        tempLinkElement.setAttribute('download', filename);
        tempLinkElement.click();
    };

    useEffect(() => {
        fetchParkings()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue])

    return <div>

        <Button className='buttonStyle addBorderRadius' title='Add Inventory Tags' variant='contained' color="secondary" disableElevation size="small" onClick={openDialog}>
            <AddIcon style={{ fontSize: "20px" }} />
        </Button>

        <Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
            <DialogContent>
                <Autocomplete id="controllable-states-demo" size="small" options={options} getOptionLabel={option => option.name} style={{ marginBottom: 20 }} value={autovalue}
                    onChange={(event, newValue) => {
                        if (newValue) {
                            setAutoValue(newValue);
                            setAccessKeyId(newValue.access_key_id)
                        }
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                    renderInput={(params) => <MuiTextField {...params} label="Parking Name" variant="outlined" />}
                />

                <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap: 20}}>
                    <MuiTextField style={{ width: 150}} label="Batch ID" size="small" variant='outlined' value={batchId} onChange={(e) => setBatchId(e.target.value)}>
                    </MuiTextField>
                    <MuiTextField style={{ width: 150}} label="Secret Code" size="small" variant='outlined' value={secretCode} onChange={(e) => setSecretCode(e.target.value)}>
                    </MuiTextField>
                    <MuiTextField style={{ width: 150 }} size="small" variant='outlined' label="File Type" select value={fileType} onChange={fileTypeHandler}>
                        <MenuItem value=".csv">Csv</MenuItem>
                        {/* <MenuItem value=".xslx">XSLX</MenuItem> */}
                    </MuiTextField>
                </div>

                <div style={{marginTop: 20}}>
                    <Button className='customCreateBtnStyle' title='Add File'>
                        <AddIcon style={{ fontSize: 22, marginRight: 10 }} />
                        {file && file.name ? file.name : "Add File"}
                        <input type="file" accept=".csv" onChange={fileHandler} style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "inherit" }} />
                    </Button>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 20 }}>
                    <div className="formLabel-regular" style={{ fontSize: 13, fontWeight: "bold" }}>Instructions:</div>
                    <Button onClick={getSampleFile} style={{fontSize: 12}}><GetAppIcon style={{fontSize: 16}} /> Sample File</Button>
                </div>
                <ol style={{ fontSize: 12, display: "flex", flexDirection: "column", gap: 4 }}>
                    <li>File must have two columns as <strong>TAG ID</strong> & <strong>RFID</strong>.</li>
                    <li>Column name <strong>VEHICLE TYPE</strong> is optional.</li>
                    <li>Columns name should be in <strong>Uppercase</strong>.</li>
                    <li>Don't use any <strong>Special Characters</strong> or <strong>Blank Space</strong>.</li>
                    <li><strong>Batch ID</strong> & <strong>Secret Code</strong> text fields are optional.</li>
                    <li>Only support <strong>CSV</strong> file type.</li>
                    <li>Please refer the <strong>Sample File</strong>.</li>
                </ol>

            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                    Close
                </Button>
                <Button onClick={onCsvUpload} variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#18cc69", color: "#FFF" }} disableElevation>
                    Upload {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}
                </Button>
            </DialogActions>
        </Dialog>
    </div>
}